export const DRAG_AND_DROP_OPTION = "files";
export const XLS_OPTION = "spreadsheet";
export const XLS_REFERENCE_OPTION = "spreadsheet-with-reference";